import { css } from '@emotion/core';
import { IconButton } from '@material-ui/core';
import React from 'react';

import { useAgent } from '../hooks/use-agent';

const orbitButtonStyles = css`
    width: 32px;
    height: 32px;
    padding: 8px;
    margin-right: 5px;

    &:hover {
        opacity: 0.9;
    }
`;

const orbitIconStyles = css`
    width: 28px;
    height: 28px;
    filter: brightness(0) invert(1);
    transform: rotate(-10deg);
`;

const ORBIT_ICON_SRC = '/images/orbit-transparent-small.png';

export const OrbitButton = () => {
    const agent = useAgent();

    return (
        <IconButton css={orbitButtonStyles} onClick={agent.onToggle}>
            <img src={ORBIT_ICON_SRC} alt="Orbit" css={orbitIconStyles} />
        </IconButton>
    );
};
